import { APP_UPDATE, APP_STORE, APP_NAVIGATE } from '../actions/app';

export const DEFAULT_STATE = {
  appName: 'Catalytic',
  navigate: false,
  page: {},
  store: {}
};

export default function app(
  state = DEFAULT_STATE,
  { type, merge, path, payload = {} }
) {
  const {
    appName = state.appName,
    navigate = state.navigate,
    search,
    ...other
  } = payload;

  switch (type) {
    case APP_UPDATE: {
      if (!path) return state;

      const currentPage = state.page[path] || {};

      const newState = !merge
        ? {
            ...state,
            appName,
            navigate,
            page: {
              ...state.page,
              [path]: {
                ...other
              }
            }
          }
        : {
            ...state,
            appName,
            navigate,
            page: {
              ...state.page,
              [path]: {
                ...currentPage,
                ...other
              }
            }
          };

      if (payload.search) {
        const newCurrentPage = newState.page[path];

        newCurrentPage.search = !merge
          ? payload.search
          : {
              ...currentPage.search,
              ...payload.search
            };
      }

      return newState;
    }
    case APP_STORE: {
      if (!path) return state;

      return !merge
        ? {
            ...state,
            appName,
            navigate,
            store: {
              ...state.store,
              [path]: other
            }
          }
        : {
            ...state,
            appName,
            navigate,
            store: {
              ...state.store,
              [path]: {
                ...state.store[path],
                ...other
              }
            }
          };
    }
    case APP_NAVIGATE:
      return { ...state, navigate: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/app.js